const StubVisibilityJs = {
  every: () => undefined,
  stop: () => undefined,
};

export default global.window === undefined ? StubVisibilityJs : require('visibilityjs');
